<template>
  <div class="page" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="card pt10 pb10" v-if="isEdit">
      {{ $t('common.boutiqueId') }}: {{ formData.productCode ? formData.productCode.toUpperCase() : '' }}
    </div>

    <div class="card">
      <p>{{ $t('product.baseInfo') }}</p>
      <el-form class="mt20" ref="editForm" :model="formData" label-width="160px">
        <el-row>
          <el-col :md="24" :lg="18" :xl="12">
            <el-form-item
              v-if="showNewD"
              :label="$t('product.wholesaleNo')"
              :rules="[{ required: true, message: $t('product.wholesaleNo') }]"
            >
              <el-select clearable filterable v-model="formData.wholesaleNo" style="width: 100%">
                <el-option v-for="item in codeList" :key="item.wholesaleNo" :label="item.wholesaleNo" :value="item.wholesaleNo"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('common.designerId')" prop="designerId">
              <el-input
                v-model="formData.designerId"
                maxlength="50"
                :placeholder="$t('product.formInput')"
                :disabled="isEdit ? (isSketch ? hasDesignerId : true) : false"
              ></el-input>
              <p class="f12 lgbase mt5">{{ $t('product.formDesignerIdTip') }}</p>
            </el-form-item>
            <el-form-item :label="$t('common.color')" prop="colorCode">
              <el-input
                v-model="formData.colorCode"
                maxlength="50"
                :placeholder="$t('product.formInput')"
                :disabled="isEdit ? (isSketch ? hasColorCode : true) : false"
              ></el-input>
              <p class="f12 lgbase mt5">{{ $t('product.formColorCodeTip') }}</p>
            </el-form-item>
            <el-form-item :label="$t('common.season')" prop="seasonCode">
              <div class="flex-item">
                <span class="sketch" v-if="isSketch">{{ formData.boutiqueSeasonCode }}</span>
                <el-select v-model="formData.seasonCode" class="full">
                  <el-option v-for="item in seasonList" :label="item.seasonCode" :value="item.seasonCode" :key="item.seasonCode"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item :label="$t('common.isCo')" prop="coFlag" v-if="showIsCo">
              <el-radio-group v-model="formData.coFlag">
                <el-radio :label="0">{{ $t('common.no') }}</el-radio>
                <el-radio :label="1">{{ $t('common.yes') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('common.category')" prop="categoryId">
              <div class="flex-item">
                <span class="sketch" v-if="isSketch"
                  >{{ formData.categoryL1 }}{{ formData.categoryL2 ? '/' + formData.categoryL2 : ''
                  }}{{ formData.categoryL3 ? '/' + formData.categoryL3 : '' }}</span
                >
                <el-cascader
                  v-model="selectedCategory"
                  :props="{ value: 'categoryId', label: 'name' }"
                  :options="categoryList"
                  @change="selectCategory"
                  class="full"
                ></el-cascader>
              </div>
            </el-form-item>
            <el-form-item :label="$t('common.brand')" prop="brandId">
              <div class="flex-item">
                <span class="sketch" v-if="isSketch">{{ formData.brandName }}</span>
                <brand-select class="full" v-model="formData.brandId" :data="brandList"></brand-select>
              </div>
            </el-form-item>
            <!-- 预售 -->
            <el-form-item
              v-if="isPreSale !== 2 || (isPreSale === 2 && formData.productType === 2)"
              :label="$t('product.isPresaleProduct')"
              prop="productType"
            >
              <el-radio-group v-model="formData.productType">
                <el-radio :label="1">{{ $t('product.normalSales') }}</el-radio>
                <el-radio :label="2">{{ $t('product.preSale') }}</el-radio>
                <!-- <el-radio :label="4" v-if="bookingFlag">{{ $t('product.reservation') }}</el-radio> -->
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="formData.productType === 2" :label="$t('product.estimatedTimeToStore')" prop="arrivalTimeMin">
              <el-date-picker
                v-model="timeRanger"
                type="daterange"
                :clearable="false"
                :unlink-panels="true"
                value-format="timestamp"
                range-separator="~"
                :default-time="['00:00:00', '23:59:59']"
                :picker-options="pickerOptions"
                style="width: 100%"
              >
              </el-date-picker>
              <!-- <el-checkbox class="mt10" v-if="isPreSale === 3" v-model="formData.isRollingPresale" :true-label="1" :false-label="0">
                {{ $t('product.setRolling') }}
              </el-checkbox> -->
            </el-form-item>
            <el-form-item v-if="formData.productType === 4" :label="$t('product.orderDays')" prop="arrivalTimeMin">
              <el-input
                v-model="formData.bookingStartDays"
                @change="changeBookingDays"
                @input="(val) => inputNum(val, 'bookingStartDays')"
                style="width: 100px"
              ></el-input>
              ~
              <el-input
                v-model="formData.bookingEndDays"
                @change="changeBookingDays"
                @input="(val) => inputNum(val, 'bookingEndDays')"
                style="width: 100px"
              ></el-input>
            </el-form-item>
            <!-- 预售 end -->

            <el-form-item :label="$t('product.formProducingArea')" prop="producingArea">
              <!-- <el-input v-model="formData.producingArea" :maxlength="20" show-word-limit :placeholder="$t('product.formInputArea')"></el-input> -->
              <el-select v-model="formData.standardMadeInId" class="full" style="width: 100%" clearable filterable>
                <el-option v-for="item in madeInStandardList" :label="item.label" :value="item.standardMadeInId" :key="item.standardMadeInId"></el-option>
              </el-select>
              <p class="f12 lgbase mt5 red">{{ $t('product.formProducingAreaTip') }}</p>
            </el-form-item>

            <el-divider class="divider">
              <span class="more-btn" @click="fold = !fold"
                >{{ $t('product.moreInfo') }} <i :class="fold ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i
              ></span>
            </el-divider>

            <template v-if="!fold">
              <el-form-item :label="$t('product.formName')" prop="productName">
                <el-input v-model="formData.productName" :maxlength="50" show-word-limit :placeholder="$t('product.formInput')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('product.formColorDesc')" prop="colorDescription">
                <el-input v-model="formData.colorDescription" :maxlength="20" show-word-limit :placeholder="$t('product.formInputColor')"></el-input>
                <p class="f12 lgbase mt5">{{ $t('product.formColorTip') }}</p>
              </el-form-item>
              <el-form-item :label="$t('product.formMaterial')" prop="composition">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 5 }"
                  v-model="formData.composition"
                  :maxlength="50"
                  show-word-limit
                  :placeholder="$t('product.formInputMaterial')"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('product.formProductDesc')" prop="productDescription">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 5 }"
                  v-model="formData.productDescription"
                  :maxlength="1000"
                  show-word-limit
                  :placeholder="$t('product.formInputDesc')"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('product.formSizeDesc')" prop="sizeDescription">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 5 }"
                  v-model="formData.sizeDescription"
                  :maxlength="200"
                  show-word-limit
                  :placeholder="$t('product.formInputSize')"
                ></el-input>
              </el-form-item>
            </template>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="card">
      <attr-info label-width="160px" label-align="right">
        <attr-info-item :label="$t('product.productPic')">
          <el-upload
            :action="uploadAction"
            :headers="headers"
            multiple
            :limit="9"
            list-type="picture-card"
            accept=".jpg,.jpeg,.png,.bmp"
            :file-list="uploadFileList"
            :on-success="uploadSuccess"
            :on-preview="handlePicturePreview"
            :on-remove="handlePictureRemove"
            :on-exceed="handleExceed"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <p class="f12 mt10">{{ $t('product.formUploadTip') }}</p>
        </attr-info-item>
      </attr-info>
      <image-viewer :z-index="2000" :initial-index="imageIndex" v-if="showViewer" :on-close="closeViewer" :url-list="boutiqueImg" />
    </div>

    <div class="card pb20 mb5">
      <p>{{ $t('product.salesInfo') }}</p>
    </div>

    <!-- <div class="card mt5 mb5 pt10 pb10" v-if="!isSketch">
      <el-checkbox class="mr20" v-if="!stockExpiryFlag" v-model="formData.expiryFlag" :true-label="1" :false-label="0">{{
        $t('product.openStockExpirationDate')
      }}</el-checkbox>
      <span><span class="red" v-if="stockExpiryFlag">*</span>{{ $t('product.expirationDate') }}</span>
      <el-date-picker
        v-model="formData.day"
        size="small"
        type="date"
        :clearable="false"
        value-format="timestamp"
        :picker-options="pickerOptions"
        :disabled="formData.expiryFlag == 0 && !stockExpiryFlag"
        style="width: 130px; margin-left: 10px"
      >
      </el-date-picker>
      <el-time-select
        v-model="formData.time"
        size="small"
        :clearable="false"
        :picker-options="{
          start: '00:00',
          step: '01:00',
          end: '23:00',
        }"
        :disabled="formData.expiryFlag == 0 && !stockExpiryFlag"
        style="width: 100px; margin-left: 5px"
      >
      </el-time-select>
    </div> -->

    <el-table class="spacing-table" :data="formData.productSkuVOS">
      <el-table-column min-width="180">
        <template slot="header" slot-scope="{}">
          <span>{{ $t('product.sizeStandard') }}</span>
          <el-select size="mini" style="width: 100%" v-model="batch.sizeStandard" placeholder="same size standard">
            <el-option v-for="item in standardSizeList" :label="item" :value="item" :key="item"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope">
          <el-input v-model.trim="scope.row.sizeStandard" :maxlength="20" size="mini" />
        </template>
      </el-table-column>
      <el-table-column prop="size" :label="$t('common.size')" min-width="180">
        <template slot-scope="scope">
          <el-input v-model.trim="scope.row.size" :maxlength="20" size="mini" />
        </template>
      </el-table-column>
      <el-table-column prop="skuCode" :label="`${$t('product.skuCode')}${!skuCodeUnique ? $t('product.notEssential') : ''}`" min-width="180">
        <template slot-scope="scope">
          <el-input v-model.trim="scope.row.skuCode" :maxlength="50" size="mini" />
        </template>
      </el-table-column>
      <el-table-column prop="skuDefectLevel" :label="$t('product.defectLevel')" v-if="isShowDefectLevel" min-width="180">
        <template slot-scope="scope">
          <el-input v-model.trim="scope.row.skuDefectLevel" readonly @click.native="showDefectLevel(scope)" size="mini" />
        </template>
      </el-table-column>
      <el-table-column prop="retailPrice" min-width="220">
        <template slot="header" slot-scope="{}">
          <template v-if="isPriceWhiteList">
            {{ $t('common.retailPrice') }}<br />
            <span class="f12">({{ originalPriceUnit }}/{{ retailPriceIncludingTax === 1 ? $t('common.incldVAT') : $t('common.excldVAT') }})</span>
          </template>
          <template v-else>
            {{ $t('common.retailPrice') + '(' + originalPriceUnit + ')' }}
          </template>
          <el-input v-model.trim="batch.retailPrice" :maxlength="9" :disabled="provideRetailPrice === 2" size="mini" />
        </template>
        <template slot-scope="scope">
          <el-input v-model.trim="scope.row.retailPrice" :maxlength="9" @change="keyUpKeyboard" :disabled="provideRetailPrice === 2" size="mini">
          </el-input>
        </template>
      </el-table-column>
      <el-table-column prop="supplyPrice" min-width="220" v-if="supplyPriceMethod === 1">
        <template slot="header" slot-scope="{}">
          <template v-if="isPriceWhiteList">
            {{ $t('common.supplyPrice') }}<br />
            <span class="f12">({{ originalPriceUnit }}/{{ includingTax === 1 ? $t('common.incldVAT') : $t('common.excldVAT') }})</span>
          </template>
          <template v-else>
            {{ $t('common.supplyPrice') + '(' + originalPriceUnit + ')' }}
          </template>
          <el-input v-model.trim="batch.supplyPrice" :maxlength="9" size="mini" />
        </template>
        <template slot-scope="scope">
          <el-input v-model.trim="scope.row.supplyPrice" :maxlength="9" @change="keyUpKeyboard" size="mini"> </el-input>
        </template>
      </el-table-column>
      <el-table-column v-if="supplyPriceMethod === 2" prop="costPrice" min-width="220">
        <template slot="header" slot-scope="{}">
          <span>{{ $t('product.costPrice') + '(' + originalPriceUnit + ')' }}</span>
          <el-input v-model.trim="batch.costPrice" :maxlength="9" size="mini" />
        </template>
        <template slot-scope="scope">
          <el-input v-model.trim="scope.row.costPrice" :maxlength="9" @change="changeCostPrice" size="mini"> </el-input>
        </template>
      </el-table-column>
      <el-table-column prop="stock" min-width="210">
        <template slot="header" slot-scope="{}">
          <span>{{ $t('common.stock') }}</span>
          <el-input v-model.trim="batch.stock" :maxlength="5" size="mini" />
        </template>
        <template slot-scope="scope">
          <el-input v-model.trim="scope.row.stock" :maxlength="5" size="mini" />
        </template>
      </el-table-column>
      <el-table-column min-width="100">
        <template slot="header" slot-scope="{}">
          <el-button size="small" @click="batchSetting">{{ $t('product.batchSet') }}</el-button>
        </template>
        <template slot-scope="scope">
          <i class="el-icon-remove-outline" @click="deleteSize(scope.$index, scope.row)"></i>
        </template>
      </el-table-column>
      <el-table-column prop="desc">
        <template slot-scope="scope">
          <i class="el-icon-warning" style="color: #ff0000" v-if="scope.row.desc"></i>
          {{ scope.row.desc }}
        </template>
      </el-table-column>
    </el-table>
    <el-button class="block-btn mt5" style="width: 100%" size="mini" type="primary" plain @click="addSize">{{ $t('common.add') }}</el-button>

    <div class="tc mt20">
      <template v-if="isEdit">
        <template v-if="isSketch">
          <el-button @click="submitSketch">{{ $t('common.save') }}</el-button>
          <el-button type="primary" @click="saveToProduct">{{ $t('product.createToSell') }}</el-button>
        </template>
        <el-button v-else type="primary" @click="submitProduct">{{ $t('product.updateProduct') }}</el-button>
      </template>
      <template v-else>
        <el-button type="primary" plain @click="submitSketch">{{ $t('product.saveSketch') }}</el-button>
        <el-button type="primary" @click="submitProduct">{{ $t('product.createProduct') }}</el-button>
      </template>
    </div>

    <el-dialog :title="$t('product.defectLevel')" :visible.sync="dialogDefectLevelVisible" width="400px">
      <div class="group-list">
        <div class="group-item">
          <p>{{ $t('product.package') }}</p>
          <el-radio-group v-model="defectLevelForm.p" @change="onChangeDefectLevel">
            <el-radio class="group-radio" label="">{{ $t('product.notSelected') }}</el-radio>
            <el-radio class="group-radio" label="P1">P1</el-radio>
            <el-radio class="group-radio" label="P2">P2</el-radio>
          </el-radio-group>
        </div>
        <div class="group-item">
          <p>{{ $t('product.accessories') }}</p>
          <el-radio-group v-model="defectLevelForm.a" @change="onChangeDefectLevel">
            <el-radio class="group-radio" label="">{{ $t('product.notSelected') }}</el-radio>
            <el-radio class="group-radio" label="A1">A1</el-radio>
            <el-radio class="group-radio" label="A2">A2</el-radio>
            <el-radio class="group-radio" label="A3">A3</el-radio>
          </el-radio-group>
        </div>
        <div class="group-item">
          <el-radio-group v-model="defectLevelForm.m" @change="onChangeDefectLevel">
            <el-radio class="group-radio" label="">{{ $t('product.notSelected') }}</el-radio>
            <el-radio class="group-radio" label="M1">M1</el-radio>
            <el-radio class="group-radio" label="M2">M2</el-radio>
            <el-radio class="group-radio" label="M3">M3</el-radio>
            <el-radio class="group-radio" label="M4">M4</el-radio>
          </el-radio-group>
        </div>
      </div>
      <el-radio class="level-item" v-model="defectLevelForm.other" @change="onChangeDefectLevelOther" label="识季无理由退货">识季无理由退货</el-radio>
      <el-radio class="level-item" v-model="defectLevelForm.other" @change="onChangeDefectLevelOther" label="New">New</el-radio>
      <el-radio class="level-item" v-model="defectLevelForm.other" @change="onChangeDefectLevelOther" label="不可售">{{
        $t('product.notAppovedSold')
      }}</el-radio>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDefectLevelVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitDefectLevel">{{ $t('common.ok') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  startOfDay, endOfDay, addDays, differenceInCalendarDays,
} from 'date-fns';
import ImageViewer from 'element-ui/packages/image/src/image-viewer.vue';
import BrandSelect from '../../components/BrandSelect';
import auth from '../../common/auth';
import { dateFormat } from '../../common/utils';
import {
  seasonList,
  getCategoryList,
  getBrandList,
  getStandardSizeList,
  getProductDetail,
  getDraft,
  queryStockExpiry,
  createProduct,
  updateProduct,
  saveDraft,
  updateDraft,
  draftToProduct,
  validProductSizes,
  getWholesaleValidList,
  getMadeInStandardList
} from '../../api/product';
import { getUserInfo } from "../../api/system"
import i18n from '@/plugins/i18n';
const priceRegex = /^\d+(\.\d{1,2})?$/;
const stockRegex = /[\.]/;
const illegalRegex = /[\u4E00-\u9FA5]/;

export default {
  name: 'ProductForm',
  components: {
    BrandSelect,
    ImageViewer,
  },
  data() {
    return {
      fullscreenLoading: false,
      isEdit: Boolean(this.$route.params.id),
      isSketch: Boolean(this.$route.query.sketch),
      fromDev: Boolean(this.$route.query.fromDev),
      formData: {
        productId: null,
        designerId: null,
        colorCode: null,
        colorDescription: null, // 颜色描述
        seasonCode: null,
        coFlag: null,
        productName: null, // 商品名称
        categoryId: null, // 商品分类
        brandId: null, // 品牌
        composition: null, // 材质
        producingArea: null, // 产地
        skuDefectLevel: null, // 瑕疵等级
        productDescription: null, // 商品描述
        sizeDescription: null, // 尺寸描述
        productSkuVOS: [], // sku列表
        productType: 1,
        expiryFlag: 0,
        day: null,
        time: null,
        isRollingPresale: 0,
        bookingStartDays: null,
        bookingEndDays: null,
        wholesaleNo: null,
        hotType: -1,
        standardMadeInId: null
      },
      fold: true,
      seasonList: [],
      brandList: [],
      categoryList: [],
      standardSizeList: [],
      timeRanger: [], // 日期range
      pickerOptions: {
        disabledDate(date) {
          const nowDate = new Date();
          nowDate.setHours(0);
          nowDate.setMinutes(0);
          nowDate.setSeconds(0);
          nowDate.setMilliseconds(0);
          if (date < nowDate) {
            return true;
          }
          return false;
        },
      },
      uploadAction: `${process.env.VUE_APP_BASE_API}/product/manage/product/uploadImg`,
      headers: {
        Authorization: auth.getToken(),
      },
      uploadFileList: [],
      boutiqueImg: [],
      imageIndex: 0,
      showViewer: false,
      batch: {
        sizeStandard: null,
        retailPrice: null,
        supplyPrice: null,
        costPrice: null,
        stock: null,
      },
      hasDesignerId: false,
      hasColorCode: false,
      selectedCategory: [],
      dialogDefectLevelVisible: false,
      defectLevelForm: {
        other: null,
        p: null,
        a: null,
        m: null,
        currRowIndex: null,
      },
      codeList: [],
      madeInStandardList: []
    };
  },
  computed: mapState({
    showIsCo: (state) => state.userinfo.coFlag === 1,
    supplyPriceMethod: (state) => state.userinfo.supplyPriceMethod,
    provideRetailPrice: (state) => state.userinfo.provideRetailPrice,
    costRetailPriceCoefficient: (state) => state.userinfo.costRetailPriceCoefficient,
    originalPriceUnit: (state) => state.userinfo.originalPriceUnit,
    stockExpiryFlag: (state) => state.userinfo.stockExpiryFlag,
    skuCodeUnique: (state) => state.userinfo.skuCodeUnique,
    isMerchant: (state) => state.userinfo.vendorType === 2,
    isPreSale: (state) => state.userinfo.isPreSale,
    isPriceWhiteList: (state) => state.userinfo.isPriceWhiteList,
    retailPriceIncludingTax: (state) => state.userinfo.retailPriceIncludingTax,
    includingTax: (state) => state.userinfo.includingTax,
    isShowDefectLevel: (state) => state.userinfo.isShowDefectLevel,
    // 是否支持预订
    bookingFlag: (state) => state.userinfo.bookingFlag,
    showNewD: (state) => state.userinfo.vendorType === 7,
  }),
  watch: {
    '$i18n.locale': function () {
      this.getMadeInStandardList();
    },
  },
  created() {
    seasonList().then((res) => {
      this.seasonList = res.data;
    });
    getCategoryList().then((res) => {
      this.categoryList = res.data.map((item) => {
        if (item.children && item.children.length > 0) {
          item.children.forEach((item2) => {
            if (item2.children && item2.children.length > 0) {
              item2.children.forEach((item3) => {
                item3.children = item3.children.length === 0 ? null : item3.children;
              });
            } else {
              item2.children = null;
            }
          });
        } else {
          item.children = null;
        }
        return item;
      });
      if (this.$route.params.id) {
        this.getProductDetail(this.$route.params.id); // 需要计算三级分类id
      }
    });
    getBrandList().then((res) => {
      this.brandList = res.data;
    });
    getStandardSizeList().then((res) => {
      if (res.data) {
        this.standardSizeList = res.data.map((item) => item.sizeStandard);
      }
    });
    getUserInfo().then((res) => {
      if (res && res.data) {
        if(res.data.vendorType === 7){
          this.getWholesaleValidList()
        }
      }
    });
    this.getMadeInStandardList()
  },
  methods: {
    clickitemdataType(e) {
      e === this.formData.hotType ? this.formData.hotType = -1 : this.formData.hotType = e
    },
    getProductDetail(boutiqueProductId) {
      let request = getProductDetail;
      if (this.isSketch) {
        request = getDraft;
      }
      request({
        boutiqueProductId,
      }).then((res) => {
        if (res.data.designerId) {
          this.hasDesignerId = true;
        }
        if (res.data.colorCode) {
          this.hasColorCode = true;
        }
        if (res.data.productType === 2) {
          this.timeRanger = [res.data.arrivalTimeMin, res.data.arrivalTimeMax];
        }
        res.data.productSkuVOS = (res.data.productSkuVOS || []).map((item) => {
          if (item.skuCode === '#') {
            item.skuCode = '';
          }
          item.desc = '';
          return item;
        });
        if (res.data.productType === 4) {
          res.data.bookingStartDays = `${differenceInCalendarDays(new Date(res.data.arrivalTimeMin), new Date())}`;
          res.data.bookingEndDays = `${differenceInCalendarDays(new Date(res.data.arrivalTimeMax), new Date())}`;
        }
        this.formData = {
          ...res.data,
          standardMadeInId: res.data.standardMadeInId || null,
          expiryFlag: 0,
          day: null,
          time: null,
        };
        // 默认0
        this.formData.coFlag = this.formData.coFlag || 0;
        this.formData.seasonCode = this.formData.seasonCode2;

        this.uploadFileList = (res.data.imgVOS || []).map((item) => ({ url: item.img }));
        this.boutiqueImg = (res.data.imgVOS || []).map((item) => item.img);

        // 选中分类
        let categoryIds = [];
        this.categoryList.some((item) => item.children.some((item2) => item2.children.some((item3) => {
          if (item3.categoryId === this.formData.categoryId) {
            categoryIds = [item.categoryId, item2.categoryId, item3.categoryId];
            return true;
          }
          return false;
        })));
        this.selectedCategory = categoryIds;

        if (!this.isSketch) {
          queryStockExpiry(this.formData.productId).then((resb) => {
            if (resb.success && resb.data) {
              this.formData.expiryFlag = resb.data.expiryFlag;
              // this.formData.day = resb.data.invalidTime;
              // this.formData.time = dateFormat(resb.data.invalidTime, 'hh:mm');
              this.formData.day = '';
              this.formData.time = '';
            } else {
              this.formData.expiryFlag = 0;
              this.formData.day = '';
              this.formData.time = '';
            }
          });
        }
      });
    },
    keyUpKeyboard() {
      this.formData.productSkuVOS.map((item) => {
        if (parseFloat(item.supplyPrice) > parseFloat(item.retailPrice)) {
          item.desc = this.$t('product.supplyPriceHigherThanRetailPrice');
        } else {
          item.desc = '';
        }
        return item;
      });
    },
    changeCostPrice() {
      this.formData.productSkuVOS.map((item) => {
        if (this.provideRetailPrice === 2) {
          if (item.costPrice === null || item.costPrice === '') {
            item.retailPrice = '';
          } else {
            item.retailPrice = (item.costPrice * this.costRetailPriceCoefficient).toFixed(2);
          }
        } else if (parseFloat(item.costPrice) > parseFloat(item.retailPrice)) {
          item.desc = this.$t('product.costPriceHigherThanRetailPrice');
        } else {
          item.desc = '';
        }
        return item;
      });
    },
    selectCategory(res) {
      this.formData.categoryId = res[2];
    },
    addSize() {
      const sizeObj = {
        boutiqueSkuId: null,
        size: '',
        sizeStandard: '',
        skuCode: '',
        retailPrice: '',
        stock: '',
        desc: '',
        skuDefectLevel: '',
      };
      if (this.supplyPriceMethod === 1) {
        sizeObj.supplyPrice = '';
      }
      if (this.supplyPriceMethod === 2) {
        sizeObj.costPrice = '';
      }
      this.formData.productSkuVOS.push(sizeObj);
    },
    deleteSize(index) {
      this.formData.productSkuVOS.splice(index, 1);
    },
    batchSetting() {
      const {
        sizeStandard, supplyPrice, retailPrice, stock, costPrice,
      } = this.batch;

      this.formData.productSkuVOS.map((item) => {
        if (sizeStandard) {
          item.sizeStandard = sizeStandard;
        }
        if (retailPrice) {
          item.retailPrice = retailPrice;
        }
        if (supplyPrice) {
          item.supplyPrice = supplyPrice;
        }
        if (costPrice) {
          item.costPrice = costPrice;
        }
        if (stock) {
          item.stock = stock;
        }
        if (parseFloat(supplyPrice) > parseFloat(retailPrice)) {
          item.desc = this.$t('product.supplyPriceHigherThanRetailPrice');
        } else {
          item.desc = '';
        }
        if (this.provideRetailPrice === 2) {
          item.retailPrice = (item.costPrice * this.costRetailPriceCoefficient).toFixed(2);
        } else if (parseFloat(item.costPrice) > parseFloat(item.retailPrice)) {
          item.desc = this.$t('product.costPriceHigherThanRetailPrice');
        } else {
          item.desc = '';
        }
        return item;
      });
    },
    checkFormData(type) {
      if (!this.formData.designerId) {
        this.$message.error(this.$t('product.pleaseInputDesignerId'));
        return false;
      }
      if (!this.isEdit && illegalRegex.test(this.formData.designerId)) {
        this.$message.error(this.$t('product.designerIdContainsIllegalCharacters'));
        return false;
      }
      if (!this.formData.colorCode) {
        this.$message.error(this.$t('product.pleaseInputColorCode'));
        return false;
      }
      if (!this.isEdit && illegalRegex.test(this.formData.colorCode)) {
        this.$message.error(this.$t('product.colorCodingContainsIllegalCharacters'));
        return false;
      }
      if (type === 'product') {
        if (!this.formData.seasonCode) {
          this.$message.error(this.$t('product.pleaseSelectSeason'));
          return false;
        }
        if (!this.formData.categoryId) {
          this.$message.error(this.$t('product.pleaseSelectCategory'));
          return false;
        }
        if (!this.formData.brandId) {
          this.$message.error(this.$t('product.pleaseSelectBrand'));
          return false;
        }
      }
      if (!this.isPreSale === 2 && (this.formData.productType === 2 || this.formData.productType === 4)) {
        this.$message.error(this.$t('product.noRightsOfPreSaleTip'));
        return false;
      }
      this.formData.arrivalTimeMin = this.timeRanger[0];
      this.formData.arrivalTimeMax = this.timeRanger[1];
      if (this.formData.productType === 4) {
        this.formData.arrivalTimeMin = startOfDay(addDays(new Date(), this.formData.bookingStartDays)).getTime();
        this.formData.arrivalTimeMax = endOfDay(addDays(new Date(), this.formData.bookingEndDays)).getTime() - 999;
      }
      if (this.formData.productType === 2 && !this.formData.arrivalTimeMin) {
        this.$message.error(this.$t('product.pleaseEnterEstimatedTime'));
        return false;
      }
      if (this.formData.productType === 4 && !this.formData.arrivalTimeMin) {
        this.$message.error(this.$t('product.pleaseEnterOrderDays'));
        return false;
      }
      if (this.formData.productSkuVOS.length <= 0) {
        this.$message({
          message: this.$t('product.pleaseAddOneSKU'),
          type: 'error',
        });
        return false;
      }
      const sizeArr = [];
      const skuCodeArr = [];
      for (let i = 0; i < this.formData.productSkuVOS.length; i++) {
        const item = this.formData.productSkuVOS[i];
        if (!item.size) {
          this.$message.error(this.$t('product.pleaseInputSize'));
          return false;
        }
        sizeArr.push(item.size);
        if (this.skuCodeUnique) {
          if (!item.skuCode) {
            this.$message.error(this.$t('product.pleaseInputSkuCode'));
            return false;
          }
          skuCodeArr.push(item.skuCode);
        }
        if (this.isShowDefectLevel) {
          if (!item.skuDefectLevel) {
            this.$message.error(this.$t('product.pleaseSelectDefectLevel'));
            return false;
          }
        }
        if (type === 'sketch') {
          // 草稿验证
          if (
            item.supplyPrice !== null &&
            item.supplyPrice !== '' &&
            item.supplyPrice !== undefined &&
            (item.supplyPrice <= 0 || !priceRegex.test(item.supplyPrice))
          ) {
            this.$message.error(this.$t('product.priceMustGreaterThan'));
            return false;
          }
          if (
            item.costPrice !== null &&
            item.costPrice !== '' &&
            item.costPrice !== undefined &&
            (item.costPrice <= 0 || !priceRegex.test(item.costPrice))
          ) {
            this.$message.error(this.$t('product.priceMustGreaterThan'));
            return false;
          }
          if (
            item.retailPrice !== null &&
            item.retailPrice !== '' &&
            item.retailPrice !== undefined &&
            (item.retailPrice <= 0 || !priceRegex.test(item.retailPrice))
          ) {
            this.$message.error(this.$t('product.priceMustGreaterThan'));
            return false;
          }
          if (item.stock !== null && item.stock !== '' && item.stock !== undefined && (item.stock < 0 || stockRegex.test(item.stock))) {
            this.$message.error(this.$t('product.inventoryMustIntegerGreaterThan'));
            return false;
          }
        } else {
          // 商品验证
          if (this.supplyPriceMethod === 1) {
            if (item.supplyPrice === null || item.supplyPrice === '') {
              this.$message.error(this.$t('product.pleaseEnterSupplyPrice'));
              return false;
            }
            if (item.supplyPrice <= 0 || !priceRegex.test(item.supplyPrice)) {
              this.$message.error(this.$t('product.priceMustGreaterThan'));
              return false;
            }
          }
          if (this.supplyPriceMethod === 2) {
            if (item.costPrice === null || item.costPrice === '') {
              this.$message.error(this.$t('product.pleaseEnterCostPrice'));
              return false;
            }
            if (item.costPrice <= 0 || !priceRegex.test(item.costPrice)) {
              this.$message.error(this.$t('product.priceMustGreaterThan'));
              return false;
            }
          }
          if (item.retailPrice === null || item.retailPrice === '') {
            this.$message.error(this.$t('product.pleaseInputRetailPrice'));
            return false;
          }
          if (item.retailPrice <= 0 || !priceRegex.test(item.retailPrice)) {
            this.$message.error(this.$t('product.priceMustGreaterThan'));
            return false;
          }
          if (item.stock === null || item.stock === '') {
            this.$message.error(this.$t('product.pleaseEnterStockQuantity'));
            return false;
          }
          if (item.stock < 0 || stockRegex.test(item.stock)) {
            this.$message.error(this.$t('product.inventoryMustIntegerGreaterThan'));
            return false;
          }
        }
      }
      if (this.skuCodeUnique) {
        const skuCodeSet = new Set(skuCodeArr);
        if (skuCodeArr.length !== skuCodeSet.size) {
          this.$message.error(this.$t('product.skuCodeCannotRepeated'));
          return false;
        }
      } else {
        const sizeSet = new Set(sizeArr);
        if (sizeArr.length !== sizeSet.size) {
          this.$message.error(this.$t('product.sizeCannotRepeated'));
          return false;
        }
      }
      // if (type === 'product' && !this.isSketch) {
      //   if (this.stockExpiryFlag || this.formData.expiryFlag) {
      //     if (!this.formData.day || !this.formData.time) {
      //       this.$message.error(this.$t('product.pleaseSelectExpirationTime'));
      //       return false;
      //     }
      //     const hmArr = this.formData.time.split(':');
      //     const hour = Number(hmArr[0]);
      //     const minutes = Number(hmArr[1]);
      //     const invalidTime = this.formData.day + hour * 60 * 60 + minutes * 60;
      //     if (invalidTime <= Date.now()) {
      //       this.$message.error(this.$t('product.expirationTimeCannotLessCurrentTime'));
      //       return false;
      //     }
      //     this.formData.invalidTime = invalidTime;
      //   }
      // }
      return true;
    },
    validePrice() {
      let flag = true;
      for (let index = 0; index < this.formData.productSkuVOS.length; index++) {
        const element = this.formData.productSkuVOS[index];
        if (
          element.retailPrice * 1 <= 10 ||
          (this.supplyPriceMethod === 1 && element.supplyPrice * 1 <= 10) ||
          (this.supplyPriceMethod === 2 && element.costPrice * 1 <= 10)
        ) {
          flag = false;
          this.$message.error(this.$t('product.priceMustThanTen'));
          break;
        }
      }
      return flag;
    },
    async validProductSizes(sizes) {
      const res = await validProductSizes(sizes);
      if (res.success) {
        return true;
      }
      this.$message.error(res.message || this.$t('error.systemerror'));
      return false;
    },
    submitSketch() {
      let request = saveDraft;
      if (this.isEdit) {
        request = updateDraft;
      }
      if (!this.checkFormData('sketch')) {
        return;
      }
      const flag = this.validePrice();
      if (!flag) return;
      this.fullscreenLoading = true;
      request({
        ...this.formData,
        boutiqueImg: this.boutiqueImg,
      }).then((res) => {
        this.fullscreenLoading = false;
        if (res.success) {
          this.$message.success(this.$t('error.successful'));
          if (this.fromDev) {
            this.$router.replace({ path: '/open/tools' });
          } else {
            this.$router.push({ path: '/product/sketch' });
          }
        } else {
          if (res.code === 14 || res.code === '14') {
            res.message = this.$t('product.expirationTimeCannotLessCurrentTime');
          }
          this.$message.error(res.message || this.$t('error.systemerror'));
        }
      });
    },
    async submitProduct() {
      let request = createProduct;
      if (this.isEdit) {
        request = updateProduct;
      }
      if (this.showNewD && !this.formData.wholesaleNo) {
         this.$message.error(this.$t('common.plzInput')+this.$t('product.wholesaleNo'));
        return;
      }
      if (!this.checkFormData('product')) {
        return;
      }
      const flag = this.validePrice();
      if (!flag) return;
      const sizeFlag = await this.validProductSizes(this.formData.productSkuVOS.map((item) => item.size));
      if (!sizeFlag) return;
      this.fullscreenLoading = true;
      request({
        ...this.formData,
        boutiqueImg: this.boutiqueImg,
      }).then((res) => {
        this.fullscreenLoading = false;
        if (res.success) {
          this.$message.success(this.$t('error.successful'));
          if (this.isEdit) {
            window.close();
          } else {
            // 创建商品
            this.$router.push({ path: '/product/list' });
          }
        } else {
          if (res.code === 14 || res.code === '14') {
            res.message = this.$t('product.expirationTimeCannotLessCurrentTime');
          }
          this.$message.error(res.message || this.$t('error.systemerror'));
        }
      });
    },
    saveToProduct() {
      if (!this.checkFormData('product')) {
        return;
      }
      const flag = this.validePrice();
      if (!flag) return;
      this.fullscreenLoading = true;
      draftToProduct(this.formData).then((res) => {
        this.fullscreenLoading = false;
        if (res.success) {
          this.$message.success(this.$t('error.successful'));
          if (this.fromDev) {
            this.$router.replace({ path: '/open/tools' });
          } else {
            this.$router.replace({ path: '/product/list' });
          }
        } else {
          if (res.code === 14 || res.code === '14') {
            res.message = this.$t('product.expirationTimeCannotLessCurrentTime');
          }
          this.$message.error(res.message || this.$t('error.systemerror'));
        }
      });
    },
    uploadSuccess(res, file, fileList) {
      this.uploadFileList = fileList;
      this.boutiqueImg = fileList.map((item) => {
        if (item.response) {
          return item.response.data;
        }
        return item.url;
      });
    },
    handlePicturePreview(file) {
      const index = this.boutiqueImg.findIndex((item) => item === file.url);
      this.imageIndex = index;
      this.showViewer = true;
    },
    closeViewer() {
      this.showViewer = false;
    },
    handlePictureRemove(file) {
      const index = this.boutiqueImg.findIndex((item) => item === file.url);
      this.uploadFileList.splice(index, 1);
      this.boutiqueImg.splice(index, 1);
    },
    handleExceed() {
      this.$message.warning(this.$t('product.upTo9Uploads'));
    },
    showDefectLevel(scope) {
      this.defectLevelForm.currRowIndex = scope.$index;

      if (!scope.row.skuDefectLevel) {
        this.defectLevelForm.other = null;
        this.defectLevelForm.p = null;
        this.defectLevelForm.a = null;
        this.defectLevelForm.m = null;
        this.dialogDefectLevelVisible = true;
        return;
      }
      if (['New', '不可售', '识季无理由退货'].includes(scope.row.skuDefectLevel)) {
        this.defectLevelForm.other = scope.row.skuDefectLevel;
        this.defectLevelForm.p = null;
        this.defectLevelForm.a = null;
        this.defectLevelForm.m = null;
      } else if (scope.row.skuDefectLevel.indexOf(',')) {
        const arr = scope.row.skuDefectLevel.split(',');
        arr.forEach((item) => {
          if (['P1', 'P2'].indexOf(item) > -1) {
            this.defectLevelForm.p = item;
          }
          if (['A1', 'A2', 'A3'].indexOf(item) > -1) {
            this.defectLevelForm.a = item;
          }
          if (['M1', 'M2', 'M3', 'M4'].indexOf(item) > -1) {
            this.defectLevelForm.m = item;
          }
        });
        this.defectLevelForm.other = null;
      }
      this.dialogDefectLevelVisible = true;
    },
    submitDefectLevel() {
      if (this.defectLevelForm.other) {
        this.formData.productSkuVOS[this.defectLevelForm.currRowIndex].skuDefectLevel = this.defectLevelForm.other;
      } else {
        const arr = [];
        if (this.defectLevelForm.p) {
          arr.push(this.defectLevelForm.p);
        }
        if (this.defectLevelForm.a) {
          arr.push(this.defectLevelForm.a);
        }
        if (this.defectLevelForm.m) {
          arr.push(this.defectLevelForm.m);
        }
        this.formData.productSkuVOS[this.defectLevelForm.currRowIndex].skuDefectLevel = arr.join(',');
      }
      this.dialogDefectLevelVisible = false;
    },
    onChangeDefectLevel() {
      this.defectLevelForm.other = null;
    },
    onChangeDefectLevelOther() {
      this.defectLevelForm.p = null;
      this.defectLevelForm.a = null;
      this.defectLevelForm.m = null;
    },
    inputNum(val, field) {
      val = val.replace(/[^\d]/g, '');
      this.formData[field] = val;
    },
    changeBookingDays() {
      if (this.formData.bookingStartDays && this.formData.bookingEndDays) {
        if (this.formData.bookingStartDays * 1 > this.formData.bookingEndDays * 1) {
          const num = this.formData.bookingStartDays;
          this.formData.bookingStartDays = this.formData.bookingEndDays;
          this.formData.bookingEndDays = num;
        }
      }
      if (Number(this.formData.bookingStartDays) < 1) {
        this.formData.bookingStartDays = 1;
      } else if (Number(this.formData.bookingStartDays) > 100) {
        this.formData.bookingStartDays = 100;
      }
      if (Number(this.formData.bookingEndDays) > 100) {
        this.formData.bookingEndDays = 100;
      }
    },
    getWholesaleValidList() {
      getWholesaleValidList().then((res) => {
        this.codeList = res.data || [];
      });
    },
    getMadeInStandardList() {
      getMadeInStandardList().then((res) => {
        this.madeInStandardList = (res.data || []).map(item => {
          return {
            ...item,
            label: i18n.locale == "en" ? item.englishName : item.name
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mb5 {
  margin-bottom: 5px !important;
}
.mt5 {
  margin-top: 5px !important;
}
.mr20 {
  margin-right: 20px !important;
}
.label {
  font-size: 12px;
  font-weight: 300;
}
.flex-item {
  display: flex;
  .sketch {
    width: 100px;
    word-break: break-all;
  }
  .full {
    flex-grow: 1;
  }
}
.more-btn {
  cursor: pointer;
  user-select: none;
}
.divider {
  margin: 30px 0;
}

.group-list {
  display: flex;
  justify-content: space-around;

  .group-item {
    width: 60px;
    padding-top: 10px;

    p {
      margin-bottom: 10px;
      text-align: center;
      font-size: 14px;
    }
    .group-radio {
      display: block;
      margin-bottom: 10px;
    }
  }

  &:hover {
    background-color: #f2f2f2;
  }
}
.level-item {
  display: block;
  // margin: 10px 0;
  padding: 10px 30px;
  margin-right: 0;

  &:hover {
    background-color: #f2f2f2;
  }
}
</style>
